// extracted by mini-css-extract-plugin
export default {"form":"PowerSearch_form__dKWTF","filters":"PowerSearch_filters__NFy-w"};